function initCountdown() {
    const daysEl = document.getElementById('countdown-days');
    const hoursEl = document.getElementById('countdown-hours');
    const minsEl = document.getElementById('countdown-mins');
    const secsEl = document.getElementById('countdown-secs');
    if (!daysEl) return;
    function updateDisplay() {
        const msRemaining = new Date(CONFIG.weddingDate) - new Date();
        if (msRemaining <= 0) {
            [
                daysEl,
                hoursEl,
                minsEl,
                secsEl
            ].forEach((el)=>el.textContent = '00');
            return;
        }
        const days = Math.floor(msRemaining / 86400000);
        const hours = Math.floor(msRemaining % 86400000 / 3600000);
        const mins = Math.floor(msRemaining % 3600000 / 60000);
        const secs = Math.floor(msRemaining % 60000 / 1000);
        daysEl.textContent = String(days).padStart(3, '0');
        hoursEl.textContent = String(hours).padStart(2, '0');
        minsEl.textContent = String(mins).padStart(2, '0');
        secsEl.textContent = String(secs).padStart(2, '0');
    }
    updateDisplay();
    setInterval(updateDisplay, 1000);
}

//# sourceMappingURL=public.414e480f.js.map
